import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useModalsStore = defineStore('modals', () => {
  const activeModals = ref([])

  const openModal = (name) => {
    if (activeModals.value.includes(name)) return
    activeModals.value.push(name)
  }

  const closeModal = (name) => {
    if (!activeModals.value.includes(name)) return
    const index = activeModals.value.indexOf(name)
    if (index === -1) return
    activeModals.value.splice(index, 1)
  }

  return {
    activeModals,
    openModal,
    closeModal,
  }
})
